import {Component, Input, OnInit} from '@angular/core';
import {NgIf} from '@angular/common';

import {EvaluationsService} from '../services/evaluations.service';

/**
 * A minute of the broadcast's sound, taken from the lineup presentation.
 *
 * That is the one stretch where a commentator is certain to be talking: the
 * graphic is up, the game is paused, and whoever commentates the broadcast
 * says the names. The tool cannot tell them from the stadium announcer — both
 * are speech through the ambient mic — but a person knows in ten seconds,
 * which is the whole point of putting the player here rather than sending
 * somebody into a three-hour recording.
 */
@Component({
  selector: 'app-evidence-audio',
  standalone: true,
  imports: [NgIf],
  template: `
    <div class="clip" *ngIf="path">
      <audio *ngIf="url" [src]="url" controls preload="none"></audio>
      <div class="failed" *ngIf="failed">sample unavailable</div>
      <div class="caption" *ngIf="caption">{{ caption }}</div>
    </div>
  `,
  styles: `
    .clip {
      padding: 4px 0;
    }

    audio {
      height: 32px;
      max-width: 320px;
    }

    .failed, .caption {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.54);
    }
  `,
})
export class EvidenceAudioComponent implements OnInit {

  @Input() path: string | null;
  @Input() caption = '';

  url: string;
  failed = false;

  constructor(private evaluations: EvaluationsService) {
  }

  ngOnInit(): void {
    if (!this.path) {
      this.failed = true;
      return;
    }
    this.evaluations.evidenceUrl(this.path)
      .then(url => this.url = url)
      .catch(() => this.failed = true);
  }
}
